import { z } from "zod";
export const IdSchema = z.string().uuid();
export const DistanceSchema = z.object({
    value: z.number().nonnegative(),
    unit: z.enum(["METERS", "KILOMETERS", "FURLONGS", "MILES", "YARDS"]),
});
const DISTANCE_CONVERSIONS = {
    METERS: 1,
    KILOMETERS: 1000,
    FURLONGS: 201.168,
    MILES: 1609.344,
    YARDS: 0.9144,
};
export function convertDistance(distance, toUnit) {
    const valueInMeters = distance.value * DISTANCE_CONVERSIONS[distance.unit];
    const convertedValue = valueInMeters / DISTANCE_CONVERSIONS[toUnit];
    return { value: convertedValue, unit: toUnit };
}
export class AppError extends Error {
    code;
    fieldErrors;
    cause;
    constructor(options) {
        super(options.message, { cause: options.cause });
        this.name = "AppError";
        this.code = options.code;
        this.fieldErrors = options.fieldErrors;
        this.cause = options.cause;
    }
    toJSON() {
        return {
            error: {
                code: this.code,
                message: this.message,
                fieldErrors: this.fieldErrors,
            },
        };
    }
}
